import { Component } from '@angular/core';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-external-production-menu',
    templateUrl: './external-production-menu.component.html',
    styleUrls: ['./external-production-menu.component.css'],
})
export class ExternalProductionMenuComponent {
    /**
     * The name of the external-production webpagemenu to load into generic webpagemnu component.
     */
    public webpageName = '';

    constructor(private state: StateService) {
        this.webpageName = this.state.getCurrentName();
    }
}
